/**
 * Register Service Worker for PWA
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/service-worker.js', {
          scope: '/'
        })

        console.log('✅ Service Worker registered successfully:', registration.scope)

        // Check for updates periodically
        setInterval(() => {
          registration.update()
        }, 60000) // Check every minute

        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker available
              console.log('🔄 New content available! Please refresh.')
              
              // Optionally show a notification to user
              if (confirm('Phiên bản mới đã có! Bạn có muốn tải lại trang?')) {
                window.location.reload()
              }
            }
          })
        })
      } catch (error) {
        console.error('❌ Service Worker registration failed:', error)
      }
    })
  } else {
    console.log('⚠️ Service Worker not supported in this browser')
  }
}

/**
 * Unregister Service Worker (for debugging)
 */
export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (let registration of registrations) {
      await registration.unregister()
    }
    console.log('✅ Service Worker unregistered')
  }
}

/**
 * Check if app is running as PWA
 */
export function isPWA() {
  return window.matchMedia('(display-mode: standalone)').matches || 
         window.navigator.standalone === true
}

/**
 * Check if app is installable
 */
export function canInstallPWA() {
  return 'serviceWorker' in navigator && 
         'PushManager' in window &&
         'Notification' in window
}

